export default function counterLogic() {
  const factsContainer = document.querySelector('.metrics__list');
  if (!factsContainer) return;

  const countersConfig = [
    { start: 2, end: 20, step: 1, duration: 1000 },
    { start: 4, end: 16, step: 1, duration: 1000 },
    { start: 25328, end: 35000, step: 204, duration: 1000 },
    { start: 4652, end: 10000, step: 333, duration: 1000 },
  ];

  let intervalIds = []; // Для зберігання інтервалів, щоб їх очищати

  const resetCounters = () => {
    const counterElements = factsContainer?.querySelectorAll('.metric__number');
    counterElements?.forEach((el, index) => {
      el.textContent = countersConfig[index]?.start?.toLocaleString();
    });
  };

  const startCounters = () => {
    const counterElements = factsContainer?.querySelectorAll('.metric__number');

    counterElements?.forEach((el, index) => {
      const { start, end, step, duration } = countersConfig[index];
      const delay = index * 200; // Затримка в 200 мс для кожного наступного
      setTimeout(() => {
        const intervalId = startCounter(start, end, step, duration, el);
        intervalIds.push(intervalId);
      }, delay);
    });
  };

  // Спостерігаємо за зміною класу
  const observer = new MutationObserver(() => {
    if (factsContainer?.classList.contains('animate-start')) {
      // Запуск лічильників
      intervalIds?.forEach(clearInterval); // Очистити попередні інтервали, якщо є
      intervalIds = [];
      startCounters();
    } else {
      // Скидання лічильників
      intervalIds?.forEach(clearInterval); // Очистити інтервали
      intervalIds = [];
      resetCounters();
    }
  });

  observer.observe(factsContainer, {
    attributes: true,
    attributeFilter: ['class'],
  });
}
function startCounter(startValue, endValue, step, duration, element) {
  const stepsCount = Math.ceil((endValue - startValue) / step);
  const interval = duration / stepsCount;

  let currentValue = startValue;
  const intervalId = setInterval(() => {
    currentValue += step;
    if (currentValue >= endValue) {
      currentValue = endValue;
      clearInterval(intervalId);
    }
    element.textContent = currentValue?.toLocaleString();
  }, interval);

  return intervalId; // Повертаємо ID інтервалу, щоб можна було його очистити
}
